import { render, staticRenderFns } from "./MoneyPlacement.vue?vue&type=template&id=329cb9ce&"
import script from "./MoneyPlacement.vue?vue&type=script&lang=js&"
export * from "./MoneyPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports